module.exports = __webpack_public_path__ + "img/waiting3.d8698759.svg";